import { render } from "./BackDoor.vue?vue&type=template&id=fec7dbc6"
import script from "./BackDoor.vue?vue&type=script&lang=js"
export * from "./BackDoor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__